import React from 'react';
import { TextInputFixed } from '../../../../forms/TextInput';
import { UrlInputRow } from '../../../../forms/UrlInputRow';
import Form from '../../../../forms/base';
import { enterKeyHandler } from '../../../../forms/utils';
import { i18n } from '../../../../i18n/forms';
export const LinkForm = React.memo(function LinkForm({ href, autoFocus, onChange, onCancel, }) {
    const [url, setUrl] = React.useState(href);
    const handleSubmit = () => {
        onChange === null || onChange === void 0 ? void 0 : onChange({ href: url });
    };
    const inputEnterKeyHandler = enterKeyHandler(handleSubmit);
    return (React.createElement(Form.Form, null,
        React.createElement(Form.Layout, null,
            React.createElement(Form.Row, { label: i18n('common_link'), help: i18n('link_url_help'), control: React.createElement(UrlInputRow, { href: url, input: React.createElement(TextInputFixed, { size: "s", hasClear: true, view: "normal", value: url, onUpdate: setUrl, placeholder: "https://", autoFocus: autoFocus, onKeyPress: inputEnterKeyHandler }) }) })),
        React.createElement(Form.Footer, { onCancel: onCancel, onSubmit: handleSubmit })));
});
